<script>
    import BootstrapCard from "../BootstrapCard.svelte";
    import {createEventDispatcher} from "svelte";
    import {linkConverterContent} from "../../data/content.js";

    const dispatch = createEventDispatcher();

    function handleClick(event) {

        const content = {
            link_converter: false,
            title: linkConverterContent.title,
            link_instructions: linkConverterContent.link_instructions
        }


        event.preventDefault();
        dispatch('openDialog', { database: content });
    }


</script>

<BootstrapCard classes="border-1 mb-0 mb-4">
    <div slot="content" class="p-0 m-0">
<!--        <h4 class="p-0 m-0 mb-3">FAQs</h4>-->

        <ul class="list-group-flush p-0 m-0">

            <li class="list-group-item px-lg-0">Having trouble accessing these resources?<br>See <a href="https://www.pcc.edu/library/services/borrowing/login-problems/" target="_blank">Why Can't I Log In?</a></li>

            <li class="list-group-item px-lg-0">Why use a database and not Google?<br>See <a href="https://vimeo.com/1123725445" target="_blank">"What are Databases &amp; Why You Need Them"</a>.</li>

            <li class="list-group-item px-lg-0">¿Por qué usar una base de datos y no Google?<br>Ve <a href="https://vimeo.com/1146102434/e57ada1ad2?share=copy&fl=sv&fe=ci" target="_blank">"¿Qué son las bases de datos y por qué las necesitas?"</a>.</li>

            <li class="list-group-item  px-lg-0">
                <button type="button"
                        id="link-converter-button"
                        class="p-0 m-0 bg-transparent border-0 text-left text-darkcyan"
                        on:click={handleClick}>Learn how to create and share links to content in databases.
                </button>
            </li>

            <li class="list-group-item px-lg-0">
                <a href="https://www.pcc.edu/library/audio-options-for-databases/"
                   target="_blank">Learn about audio options for databases.</a>
            </li>
        </ul>
    </div>
</BootstrapCard>
